module.exports = __webpack_public_path__ + "img/banner01.f364352b.webp";